import React from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useUi } from "@jelly/lesson";
import { useIntl } from "react-intl";

import { messages } from "./Introduction.messages";
import styles from "./Introduction.module.scss";

import * as appConfig from "appConfig";
import { SpatialCarousel } from "../../..";
import { PhotoView } from "../../../photo-view/PhotoView";

interface Introduction {
  title: string;
}

export const Introduction: React.FC<Introduction> = ({ title }) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <StandardCase
      title={title}
      leftComponent={
        <ui.Scrollbars>
          <div className={styles.C8_P1_S1_Title}>{formatMessage(messages.C8_P1_S1_Description)}</div>
        </ui.Scrollbars>
      }
    >
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/*/}
          <SpatialCarousel>
            {Array.from({ length: 4 }, (_, index) => (
              <div className={styles.carouselItem} key={index}>
                <PhotoView
                  imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case/case08/introduction/pic${index + 1}.png`}
                  imgMode={"contain"}
                />
              </div>
            ))}
          </SpatialCarousel>
        </div>
      </div>
    </StandardCase>
  );
};
